export default __webpack_public_path__ + "static/media/facebook.8d5313eb.png";